import { ANIMATION_DURATION } from './constants';

export default (theme) => ({
    '@keyframes cylonSweep': {
        '0%, 100%': { backgroundPosition: '150% center' },
        '50%': { backgroundPosition: '-50% center' },
    },
    container: {
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        position: 'relative',
        width: '100%',
        '&::before, &::after': {
            content: '""',
            position: 'absolute',
            display: 'block',
            left: 0,
            height: 20,
            width: '100%',
            zIndex: 1,
        },
        '&::before': {
            top: -10,
            background:
                'linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))',
        },
        '&::after': {
            bottom: -10,
            background: 'linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))',
        },
    },
    phrase: {
        ...theme.typography.caption,
        alignItems: 'center',
        color: theme.colors.textLight.primary,
        display: 'inline-flex',
        gap: 6,
        height: '100%',
        justifyContent: 'center',
        left: 0,
        opacity: 1,
        overflow: 'hidden',
        position: 'absolute',
        right: 0,
        textAlign: 'center',
        transition: `transform ${ANIMATION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1), opacity ${ANIMATION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1)`,
        whiteSpace: 'nowrap',
        zIndex: 0,
    },
    phraseDone: {
        color: theme.colors.textLight.jadeAccessible,
    },
    phraseTop: {
        top: '-5%',
        transform: 'translateY(-50%) scale(0.9)',
        opacity: 0.35,
    },
    phraseCenter: {
        top: '50%',
        transform: 'translateY(-50%)',
    },
    phraseBottom: {
        top: '105%',
        transform: 'translateY(-50%) scale(0.9)',
        opacity: 0.35,
    },
    phraseEmpty: {
        opacity: '0 !important',
        pointerEvents: 'none',
    },
    isInitialLoading: {
        ...theme.typography.body,
        '& > span': {
            display: 'inline-flex',
            overflow: 'hidden',
            paddingTop: 4,
            background: `linear-gradient(90deg, ${theme.colors.textLight.primary} 35%, ${theme.colors.primary.white} 50%, ${theme.colors.textLight.primary} 65%)`,
            backgroundSize: '200% 100%',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            color: 'transparent',
            WebkitTextFillColor: 'transparent',
            animation: '$cylonSweep 2.5s ease-in-out infinite',
        },
    },
});
